import * as React from "react";

import { type VariantProps } from "class-variance-authority";

import { cn } from "~/lib/utils";

import { badgeVariants } from "./badge-utils";

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>,
        VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
    ({ className, variant, ...props }, ref) => (
        <div
            ref={ref}
            className={cn(badgeVariants({ variant }), className)}
            {...props}
        />
    ),
);
Badge.displayName = "Badge";

export { Badge };
